var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardArrowDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KeyboardArrowDownRounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.12021 9.28957L12.0002 13.1696L15.8802 9.28957C16.2702 8.89957 16.9002 8.89957 17.2902 9.28957C17.6802 9.67957 17.6802 10.3096 17.2902 10.6996L12.7002 15.2896C12.3102 15.6796 11.6802 15.6796 11.2902 15.2896L6.70021 10.6996C6.31021 10.3096 6.31021 9.67957 6.70021 9.28957C7.09021 8.90957 7.73021 8.89957 8.12021 9.28957Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowDownIcon);
export default __webpack_public_path__ + "static/media/keyboard-arrow-down-icon.805a90f1676d76a2ff78b16915ed1e26.svg";
export { ForwardRef as ReactComponent };